"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.load = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var files = [
// "gun_violence",
"mass_shootings_from_columbine", "gun_violence_by_month", "firearms_manufactured", "ar_15_2016_18", "media", "school_shootings"];
var parse = require('csv-parse');

var dataPromises = files.map(function (name) {
  return fetch('./data/' + name + '.csv').then(function (rows) {
    return rows.text();
  }).then(function (text) {
    return new _promise2.default(function (resolve, reject) {
      parse(text, {}, function (_, lines) {
        return resolve(lines);
      });
    });
  }).then(function (lines) {
    // console.log(name, lines)
    var h = lines.shift();
    return {
      name: name,
      h: h,
      lines: lines.filter(function (s) {
        return !!s;
      })
    };
  });
});
var allPromises = _promise2.default.all(dataPromises).then(function (data) {
  return data.reduce(function (a, b) {
    // console.log(b)
    a[b.name] = b;
    return a;
  }, {});
});
var load = function load() {
  return allPromises;
};

exports.load = load;


//////////////////
// WEBPACK FOOTER
// ./client/data.js
// module id = 134
// module chunks = 0